export default {
  'pages.login.success': 'Login successful!',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.required': 'Please input your password!',
  // Login page
  'login.welcomeBack': 'Welcome Back',
  'login.welcomeSubtitle': 'Sign in to access your account',
  'login.copyright': 'All Rights Reserved',
  'login.signIn': 'Sign In',
  'login.signInSubtitle': 'Please enter your account information',
  'login.username': 'Username',
  'login.usernamePlaceholder': 'Please enter username',
  'login.password': 'Password',
  'login.passwordPlaceholder': 'Please enter password',
  'login.loginToDashboard': 'Login to Dashboard',
  // 404
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  // Placeholder pages
  'pages.placeholder.title': 'Page Title',
  'pages.placeholder.content': 'Page Content',
};
